import { useContext, useEffect } from 'react';

import { LOOM_PAGE_HEADER_CONTENT_INSERTION } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { useLoomInsertUrlState } from '@confluence/loom-insert-url-store';
import { useNativeCollabState } from '@confluence/native-collab/entry-points/useNativeCollabState.ts';
import type { FullPageEditorPresetAPI } from '@confluence/editor-presets/entry-points/useFullPageEditorPreset.ts';

export const useFullPageEditorLoomInsertion = (editorPresetAPI?: FullPageEditorPresetAPI): void => {
	const experienceTracker = useContext(ExperienceTrackerContext);
	const [{ collabEditInitialized }] = useNativeCollabState();
	// FIXME: https://product-fabric.atlassian.net/browse/ED-25722

	const [loomInsertUrlState, loomInsertUrlActions] = useLoomInsertUrlState();

	useEffect(() => {
		try {
			/**
			 * Insert Loom video at the top of the editor.
			 * Ensure the collab service plugin and editorPresetAPI have been initialized
			 * and the Loom video is present, to prevent premature Loom video insertion.
			 * After insertion, delete the Loom video to ensure no more insertions occur.
			 */
			if (collabEditInitialized && editorPresetAPI && loomInsertUrlState.fullPageEditorLoomUrl) {
				editorPresetAPI?.loom?.actions.insertLoom(
					{
						sharedUrl: loomInsertUrlState.fullPageEditorLoomUrl.sharedUrl,
						title: loomInsertUrlState.fullPageEditorLoomUrl.title || '',
					},
					'start',
				);
				loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
				experienceTracker.succeed({
					name: LOOM_PAGE_HEADER_CONTENT_INSERTION,
					attributes: {
						inserted: true,
					},
				});
			}
		} catch (error) {
			loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
			experienceTracker.fail({
				name: LOOM_PAGE_HEADER_CONTENT_INSERTION,
				error,
			});
		}
	}, [
		collabEditInitialized,
		editorPresetAPI,
		experienceTracker,
		loomInsertUrlActions,
		loomInsertUrlState.fullPageEditorLoomUrl,
	]);
};
